import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  selector: 'doc-grid-view-card',
  standalone: true,
  imports: [CommonModule, PdfViewerModule, NgbTooltipModule],
  templateUrl: './doc-grid-view-card.component.html',
  styleUrls: ['./doc-grid-view-card.component.scss'],
})
export class DocGridViewCardComponent {
  @Input() title = '';
  @Input() fallbackAlt = '';
  @Input() imageSrc: string | null | undefined;
  @Input() videoSrc: string | null | undefined;
  @Input() pdfSrc: string | null | undefined;
  @Input() fallbackIconSrc: string | null | undefined;
  @Input() previewable = false;
  @Input() expanded = false;
  @Input() cardClass: any = '';
  @Input() cardStyle: { [key: string]: any } | null = null;
  @Input() footerClass: any = '';
  @Input() selectable = false;
  @Input() showCheckbox = false;
  @Input() selected = false;

  @Output() cardClick = new EventEmitter<Event>();
  @Output() previewError = new EventEmitter<Event>();
  @Output() selectedChange = new EventEmitter<boolean>();
  @Output() checkboxClick = new EventEmitter<Event>();

  onCardClick(event: Event): void {
    const target = event.target as HTMLElement | null;
    if (
      target?.closest('.action-wrapper') ||
      target?.closest('.more-actions-btn') ||
      target?.closest('.favourite-indicator') ||
      target?.closest('[grid-card-badge]') ||
      target?.closest('doc-popup-menu') ||
      target?.closest('.doc-popup-menu-host') ||
      target?.closest('.dropdown-menu') ||
      target?.closest('.checkbox-wrapper')
    ) {
      return;
    }
    this.cardClick.emit(event);
  }

  onCheckboxClick(event: Event): void {
    event.stopPropagation();
    this.selected = !this.selected;
    this.selectedChange.emit(this.selected);
    this.checkboxClick.emit(event);
  }
}
